import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const useTemplateCategoryOptions = () => {
  const {
    data: templateCategoryOptions,
    isLoading: isTemplateCategoryOptionsLoading,
    refetch: refetchTemplateCategoryOptions,
  } = useQuery({
    queryKey: ["templateCategoryOptions"],
    queryFn: () => dropdownService.getTemplateCategoryOptions(),
  });

  return {
    templateCategoryOptions: templateCategoryOptions || [],
    isTemplateCategoryOptionsLoading,
    refetchTemplateCategoryOptions,
  };
};

